// extracted by css-extract-rspack-plugin
export default {"TimeAxisTickLabel":"TimeAxisTickLabel--R82_o SvgText--jvreC"};